var a = { exports: {} };
export {
  a as __module
};
//# sourceMappingURL=index.es304.js.map
